module.exports = __webpack_public_path__ + "img/clover.444a94f1.png";